import React from "react";
import { formatCLP } from "../utils/format";

// Dos barras comparativas (Toyota vs vehículo actual) con etiqueta de valor.
const BarChart = ({ bars }) => {
    const max = Math.max(...bars.map((b) => Math.abs(b.value) || 0), 1);

    return (
        <div className="savings-calculator__chart">
            <div className="savings-calculator__bars">
                {bars.map((bar, i) => (
                    <div key={i} className="savings-calculator__bar-col">
                        <span className="savings-calculator__bar-value">
                            {formatCLP(bar.value)}
                        </span>
                        <div
                            className={`savings-calculator__bar savings-calculator__bar--${bar.color}`}
                            style={{ height: `${Math.max((Math.abs(bar.value) / max) * 100, 4)}%` }}
                        />
                    </div>
                ))}
            </div>
            <div className="savings-calculator__bar-labels">
                {bars.map((bar, i) => (
                    <div key={i} className="savings-calculator__bar-label">
                        <strong>{bar.label}</strong>
                        {bar.sublabel ? <span>{bar.sublabel}</span> : null}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BarChart;
